import { Component, OnInit } from '@angular/core';
import { FileListComponent } from '@app/shared/components/file-upload/file-list.component';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';

@Component({
  selector: 'file-thumbnails-list',
  templateUrl: './file-thumbnails-list.component.html',
  styleUrls: ['./file-thumbnails-list.component.scss']
})
export class FileThumbnailsListComponent extends FileListComponent implements OnInit {

  constructor(protected componentServiceBundle: ComponentServiceBundle) {
    super(componentServiceBundle);
    this._idPrefix = 'thumbnails_list.';
  }

  public ngOnInit() {
    super.ngOnInit();
  }


}
